export interface IConversationIDsAPIResponse {
  communicationId: number;
  routingUniqueId: string;
  sessionId: string;
  callDetailRecordId: number;
  siteId: number;
}

export interface IConversationIDsAPIResponseNormalized {
  callDetailId: number;
  aceCommunicationId: number;
  aceSessionId: string;
  routingId: string;
  siteId: number;
}

export class ConversationIDsAPIResponseModel implements IConversationIDsAPIResponseNormalized {
  callDetailId: number = 0;
  aceCommunicationId: number = 0;
  aceSessionId: string = '';
  routingId: string = '';
  siteId: number = 0;

  constructor(data?: IConversationIDsAPIResponse) {
    this.callDetailId = data?.callDetailRecordId ?? this.callDetailId;
    this.aceCommunicationId = data?.communicationId ?? this.aceCommunicationId;
    this.aceSessionId = data?.sessionId ?? this.aceSessionId;
    this.routingId = data?.routingUniqueId ?? this.routingId;
    this.siteId = data?.siteId ?? this.siteId;
  }
}
